import { render, staticRenderFns } from "./productCommon.vue?vue&type=template&id=35692c73&scoped=true"
import script from "./productCommon.vue?vue&type=script&lang=js"
export * from "./productCommon.vue?vue&type=script&lang=js"
import style0 from "./productCommon.vue?vue&type=style&index=0&id=35692c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35692c73",
  null
  
)

export default component.exports